import { createFeatureSelector, createSelector } from '@ngrx/store';

import { devicesAdapter, type DevicesState } from './devices.reducer';

const { selectAll } = devicesAdapter.getSelectors();

export const selectDevicesState = createFeatureSelector<DevicesState>('devices');

export const selectAllDevices = createSelector(selectDevicesState, selectAll);

export const getDeviceBySpaceId = (roomId: string) =>
  createSelector(selectAllDevices, state => {
    return state.filter(device => (device?.spacePath?.[1]?.id || device?.parentSpaceId) === roomId);
  });

export const getDeviceById = (deviceId: string) =>
  createSelector(selectAllDevices, state => state.find(device => device.id === deviceId));

export const getDeviceModels = createSelector(selectDevicesState, state => state.models);

export const getAttributes = createSelector(selectDevicesState, state => state.attributes);

export const getActionPoints = createSelector(selectDevicesState, state => state.actionPoints);

export const isDeviceUpdating = createSelector(selectDevicesState, state => state.isDeviceUpdating);

export const getDeviceError = createSelector(selectDevicesState, state => state.error);
